import {FormControl, FormHelperText, MenuItem, Select, SelectProps, makeStyles} from '@material-ui/core';
import {ExpandMore} from '@material-ui/icons';
import {A360Lookup} from 'Quoting/models/DTOs/QuoteForm';
import classNames from 'classnames';
import React from 'react';
import {InputProps} from '../../models/FormInputs';
import {useEnabledSelectStyles} from './styles';

type QuoteDropdownProps = SelectProps &
  InputProps & {helperText?: React.ReactNode; error?: boolean} & {
    options?:
      | Array<Pick<A360Lookup, 'code' | 'displayValue'> & Partial<Pick<A360Lookup, 'orderNo'>>>
      | Array<{displayValue: string; code: any; disabled?: boolean}>;
  };

const useDropdownStyles = makeStyles(() => ({
  quoteDropdown: (props: QuoteDropdownProps) => ({
    borderRadius: 0,
    marginTop: '0.5rem',
    marginBottom: '0.25rem',
    backgroundColor: props.disabled ? '#f1f1f1' : 'transparent',
    '& > div': {
      paddingTop: '0.656rem',
      paddingBottom: '0.656rem',
    },
  }),
}));

export const QuoteDropdown = (props: QuoteDropdownProps) => {
  const {label, options, className, inputFieldProps, helperText, error, ...otherProps} = props;
  const classes = useDropdownStyles({...props});
  const enabledSelectInputStyles = useEnabledSelectStyles();

  return (
    <FormControl fullWidth error={error}>
      <Select
        inputProps={{style: inputFieldProps?.style}}
        className={classNames(classes.quoteDropdown, className, {
          [enabledSelectInputStyles.input]: otherProps.disabled === false,
        })}
        fullWidth
        variant="outlined"
        IconComponent={ExpandMore}
        {...otherProps}
        style={{
          borderRadius: 0,
          backgroundColor: props.disabled ? '#E8E8E8' : 'transparent',
          color: props.disabled ? '#474747' : '#000',
        }}
      >
        {Array.isArray(options) && options.length > 0
          ? (options as Array<{code: string; displayValue: string; disabled?: boolean}>).map(option => {
              const {code, displayValue} = option;
              return (
                <MenuItem value={code} key={`dropdown-${code}-${displayValue}`} disabled={option.disabled}>
                  {displayValue}
                </MenuItem>
              );
            })
          : null}
      </Select>
      <FormHelperText>{helperText ?? ''}</FormHelperText>
    </FormControl>
  );
};
